import { RowDetails } from "../../api-models/response/DataGridResponse";
import { PropertyType } from "../../generated/SewerObjects";
import { formatNumberBasedOnLanguage, secondsToMinutesAndSeconds } from "../../helpers/MathHelpers";
import dateService from "../../services/date-service/DateService";
import { DisplayValues } from "./interfaces";

export const formatValues = (
  rowDetails: DisplayValues | RowDetails
): DisplayValues | RowDetails => {
  Object.keys(rowDetails).forEach((key) => {
    rowDetails[key].toDisplay = rowDetails[key].value;

    if (rowDetails[key].value) {
      if (rowDetails[key].metadata!.type === PropertyType.Date)
        rowDetails[key].toDisplay = dateService.formatDate(rowDetails[key].value);
      if (
        rowDetails[key].metadata!.type === PropertyType.Decimal ||
        rowDetails[key].metadata!.type === PropertyType.Double ||
        rowDetails[key].metadata!.formatString === "D2"
      )
        rowDetails[key].toDisplay = formatNumberBasedOnLanguage(rowDetails[key].value);

      if (rowDetails[key].metadata!.type === PropertyType.VideoPositionTime) {
        const videoPositionValue = parseInt(rowDetails[key].value!);
        rowDetails[key].toDisplay = secondsToMinutesAndSeconds(videoPositionValue);
      }

      if (rowDetails[key].metadata!.catalog) {
        const catalogValue = rowDetails[key].metadata!.catalog?.find(
          (x) => x.key.trim() === rowDetails[key].value?.trim()
        );
        rowDetails[key].toDisplay = catalogValue?.value;
      }

      if (rowDetails[key].metadata!.unit) {
        rowDetails[key].toDisplay += ` ${rowDetails[key].metadata!.unit}`;
      }
    }
  });
  return rowDetails;
};
